<template>
	<section
		v-if="triggerCookie"
		class="fixed-top black-body z-cookie"
		:class="[isCookie ? fadeOut : '' || !isCookie ? fadeIn : '']"
	>
		<div class="container-fluid">
			<div class="row">
				<div class="col-xl-12">
					<div class="d-flex flex-row align-items-center cookie-banner">
						<div class="button-container">
							<button
								v-on:click="createCookie()"
								type="button"
								id="cookie-btn"
								class=" headline-module-small pr-2 pl-1 pb-2 pt-2 bold"
							>
								<span class="material-icons">
									close
								</span>
							</button>
						</div>
						<div class="cookie-text-container pb-2 pl-3 pl-xl-2 pr-2 pt-0">
							<div class="cookie-headline bold pb-1">
								stegi.radio uses cookies
							</div>
							<div class="cookie-text headline-module-small pb-1">
								We use cookies to personalise content and ads, to provide social
								media features and to analyse our traffic. We also share
								information about your use of our site with our social media,
								advertising and analytics partners who may combine it with other
								information that you’ve provided to them or that they’ve
								collected from your use of their services.
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<style scoped>
.z-cookie{
	z-index: 2004;
}
.cookie-banner {
	height: auto;
}
.cookie-text-container {
	position: relative;
}
@media (min-width: 1200px) {
	.cookie-text-container {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}
	.cookie-banner {
		height: 100px;
	}
}
</style>
<script>
export default {
	name: "CookiesComponent",

	data() {
		return {
			isCookie: true,
			fadeOut: "slide-out-top",
			fadeIn: "slide-in-top",
			triggerCookie: false,
		};
	},
	mounted() {
		this.$nextTick(function() {
			setTimeout(() => {
				this.getCookie();

				this.checkCookie();
			}, 1000);
		});
	},
	methods: {
		createCookie(cname, cvalue, exdays) {
			cname = "mvmntRadioCookie";
			exdays = 30;
			cvalue = true;
			var d = new Date();
			d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
			var expires = "expires=" + d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
			//console.log(expires);
			this.isCookie = true;
			setTimeout(() => {
				this.triggerCookie = false;
			}, 1000);
		},
		getCookie(cname) {
			var name = cname + "=";
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(";");

			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) === " ") {
					c = c.substring(1);
				}
				if (c.indexOf(name) === 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		},
		checkCookie() {
			if (!this.getCookie("mvmntRadioCookie")) {
				this.isCookie = false;
				this.triggerCookie = true;
				//console.log("no cookie yet");
			} else {
				//console.log(" cookie ");
				this.isCookie = true;
			}
		},
	},
};
</script>
